// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TrendsComponent-module__mainContainer","brdCrmb":"TrendsComponent-module__brdCrmb"};